import { knglibApi, qidaApi } from 'yxt-biz-pc/packages/api';

// 知识库列表
export const getLibs = (params) => {
  return knglibApi.post('/kngLib/optionalLibs', params);
};
// 添加到知识库
export const addKng = (params) => {
  return knglibApi.post('/knowledge/collect', params);
};
// 创建目录
export const addEditKngLib = (info) => {
  return knglibApi.post('/kngLib/save', info);
};
// 知识目录树
export const getKngLibCatalogtree = (params) => {
  return knglibApi.post('/kngLib/catalogtree', params);
};

// 获取当前环境域名
export const getOrgUrl = (orgId) => {
  return qidaApi.get(`org/base/url?orgId=${orgId}`);
};
